import { IShippingAddressDTO } from 'pages/CheckoutPage/types';

export enum OrderTabsEnum {
  Company = 'company',
  Products = 'products',
  Overview = 'overview',
  Details = 'details',
}

export enum OrderProductsSteps {
  Selection = 'selection',
  Configuration = 'configuration',
}

export interface IDetailsOrderData {
  shipping_type: ShippingType;
  order_reference: string;
  requested_delivery_date: string;
  shipping_address_code: string | null;
  shipping_address_data: IShippingAddressDTO | null;
  is_pickup: boolean;
  validDetails: boolean;
}

export enum ShippingType {
  DEFAULT = 'Default Address',
  PREDEFINED = 'Predefined Address',
  CUSTOM = 'Custom Address',
  PICKUP = 'Pickup',
}

export interface IDetailsQuotationData {
  first_name: string;
  last_name: string;
  title: string;
  email: string;
  phone: string;
  country: string;
  zip_code: string;
  house_number: string;
  city: string;
  street: string;
  company_name: string;
  vat_number: string;
  reference: string;
  days_valid: string;
  hasAlternativeShippingAddress: boolean;
  alt_country: string;
  alt_zip_code: string;
  alt_house_number: string;
  alt_city: string;
  alt_street: string;
  validDetails: boolean;
}
